import { createTimeline } from 'animejs';

export default function Listings_Animation(animation_el) {
	const card_els = animation_el.getElementsByClassName(`card`);

	const tl = createTimeline({
		autoplay: false,
		loop: true,
		loopDelay: 1800,
	});

	let scale = 1 - 0.1 * card_els.length;
	scale = Math.max(scale, 0);

	let pct = animation_el.offsetHeight / 10 - card_els.length * 10;

	pct = Math.max(pct, 0);

	for (let i = 0; i < card_els.length; i++) {
		scale += 0.1;
		scale = Math.min(scale, 1);

		pct += 10;
		pct = Math.min(pct, 100);

		const card_el = card_els[i];

		tl.add(card_el, {
			top: `${pct}%`,
			duration: 800,
			opacity: 1,
		});

		tl.add(card_el, {
			duration: 800,
			scale,
		});
	}

	function set_height() {
		let max_height = 0;

		for (let i = 0; i < card_els.length; i++) {
			const card_el = card_els[i];

			let height = card_el.offsetHeight;

			height += height * 0.2;

			height += i * 24;

			if (height > max_height) {
				max_height = height;
			}
		}

		animation_el.style.height = `${max_height}px`;
	}

	set_height();

	// Debounce resize listener to improve performance
	let resize_timeout = null;

	const debounced_set_height = () => {
		if (resize_timeout) {
			clearTimeout(resize_timeout);
		}

		resize_timeout = setTimeout(set_height, 150);
	};

	window.addEventListener(`resize`, debounced_set_height);

	return {
		play: () => {
			tl.play();
		},
		pause: () => {
			tl.pause();
		},
	};
}
